'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WinresKvBookingProcess]');

var WinresKvBookingProcessController = function () {
    function WinresKvBookingProcessController($scope, $uibModal) {
        _classCallCheck(this, WinresKvBookingProcessController);

        this.$scope = $scope;
        this.$uibModal = $uibModal;
    }

    _createClass(WinresKvBookingProcessController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // console.log('Parent popup:', this.parentPopup);
            this.context = this.parentPopup.resolve.context;
            var data = this.context.getContext();
            this.data = data;
            this.amountToPay = null;

            this.has = {
                lines: false,
                amountToPay: false,
                customerInfo: false,
                acceptTerms: false,
                giftCards: true // Ready by default, set to not-ready if something is pending.
            };

            this.$scope.$watch(function () {
                return data.Products.length > 0;
            }, function (hasLines) {
                return _this.onHasLinesChange(hasLines);
            });

            this.$scope.$watch(function () {
                return _this.context.amountToPay;
            }, function (amountToPay) {
                return _this.onAmountToPayChange(amountToPay);
            });

            this.$scope.$watch(function () {
                return data.AcceptTerms;
            }, function (acceptTerms) {
                return _this.onAcceptTermsChange(acceptTerms);
            });

            this.$scope.$on('winresPrebookError', function (event, data) {
                return _this.onPrebookError(event, data);
            });
        }
    }, {
        key: 'onCustomerInfoInit',
        value: function onCustomerInfoInit(controller) {
            var _this2 = this;

            this.$scope.$watch(function () {
                return controller.customerForm.$error;
            }, function (errors) {
                return _this2.onCustomerInfoErrorsChange(errors, controller.customerForm);
            }, true);

            // Only react to customer info changes when the info is valid.
            // This will still trigger a lot if the customer changes valid info,
            // but the payment methods component will wait for it to settle before
            // querying the backend.
            this.$scope.$watch(function () {
                return _this2.has.customerInfo ? JSON.stringify(_this2.data.Customer) : '';
            }, function (c) {
                return _this2.onCustomerInfoChange(c);
            });
        }
    }, {
        key: 'onHasLinesChange',
        value: function onHasLinesChange(hasLines) {
            // NOTE: This does not include discount lines.
            log('Has lines:', hasLines);
            this.has.lines = hasLines;
        }
    }, {
        key: 'onAmountToPayChange',
        value: function onAmountToPayChange(amountToPay) {
            this.amountToPay = amountToPay;
            this.has.amountToPay = amountToPay === 0 || amountToPay > 0;
            log('Has amount to pay:', this.has.amountToPay);
            this.onAmountToPayOrGiftCardsChange();
        }
    }, {
        key: 'onGiftCardsStateChange',
        value: function onGiftCardsStateChange(pending) {
            this.has.giftCards = !pending;
            log('Has gift cards ready:', this.has.giftCards);
            this.onAmountToPayOrGiftCardsChange();
        }
    }, {
        key: 'onAmountToPayOrGiftCardsChange',
        value: function onAmountToPayOrGiftCardsChange() {
            if (this.has.amountToPay && this.has.giftCards) {
                this.amountToPayAfterGiftCards = this.amountToPay - _.sumBy(this.data.GiftCards, function (x) {
                    return x.Amount;
                });
                this.$scope.$broadcast('updatePaymentMethods');
            } else {
                this.amountToPayAfterGiftCards = null;
            }
        }
    }, {
        key: 'onCustomerInfoChange',
        value: function onCustomerInfoChange(c) {
            if (this.has.customerInfo) {
                // log('Customer info has changed and is valid.', c);
                this.$scope.$broadcast('updatePaymentMethods');
            }
        }
    }, {
        key: 'onCustomerInfoErrorsChange',
        value: function onCustomerInfoErrorsChange(errors, form) {
            var _this3 = this;

            log('Customer info errors:', _.cloneDeep(errors));
            var known = angular.isObject(errors);
            var values = Object.keys(errors).length > 0;
            if (known && !values) {
                // All done.
                this.customerInfoErrors = [];
                this.has.customerInfo = true;
            } else if (known && values) {
                // Something missing.
                this.customerInfoErrors = [];

                _.each(errors, function (controls, validator) {
                    _.each(controls, function (control) {
                        if (control.$pristine && control.$viewValue === undefined) {
                            return;
                        }
                        var field = control.$name;
                        _this3.customerInfoErrors.push({
                            field: 'reservation_customer.' + field,
                            error: ['kv_booking_process.customer_info_errors.' + validator, 'kv_booking_process.customer_info_errors.other']
                        });
                    });
                });
                this.has.customerInfo = false;
            } else {
                // No information for some reason.
                this.customerInfoErrors = [];
                this.has.customerInfo = false;
            }
            log('Has customer info:', this.has.customerInfo, this.customerInfoErrors);
        }
    }, {
        key: 'onAcceptTermsChange',
        value: function onAcceptTermsChange(acceptTerms) {
            this.has.acceptTerms = !!acceptTerms;
            log('Has accepted terms:', this.has.acceptTerms);
        }
    }, {
        key: 'onPrebookError',
        value: function onPrebookError(event, data) {
            log('Prebook error:', event, data);
            this.$uibModal.open({
                template: require('./prebookErrorModal.html'),
                controller: ['$scope', function ($scope) {
                    $scope.error = { data: data };
                }]
            });
            // alert(this.$filter('i18next')('reservation_customer.error_terms'));
        }
    }]);

    return WinresKvBookingProcessController;
}();

WinresKvBookingProcessController.$inject = ['$scope', '$uibModal'];

_module3.default.component('winresKvBookingProcess', {
    template: require('./winresKvBookingProcess.html'),
    controller: WinresKvBookingProcessController,
    bindings: {},
    require: {
        parentPopup: '^^winresShoppingCartModalPopup'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresKvBookingProcess/winresKvBookingProcess.js
// module id = 519
// module chunks = 2